import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import SiteLayout from "./components/SiteLayout";
import QaHome from "./pages/QaHome";
import QaCaseStudy from "./pages/QaCaseStudy";
import Projects from "./pages/Projects";
import Capabilities from "./pages/Capabilities";
import LocalizedContact from "./pages/LocalizedContact";
import { Legal, Privacy } from "./pages/LocalizedLegal";

function LocaleGuard() {
  const { locale } = useParams();
  return locale === "de" || locale === "en" ? <SiteLayout /> : <Navigate to="/de/" replace />;
}

function ArchiveRedirect() {
  const { locale = "de" } = useParams();
  return <Navigate to={`/${locale}/projects/`} replace />;
}

export default function App() {
  return <><ScrollToTop /><Routes>
    <Route path="/" element={<Navigate to="/de/" replace />} />
    <Route path="/:locale" element={<LocaleGuard />}>
      <Route index element={<QaHome />} />
      <Route path="projects" element={<Projects />} />
      <Route path="projects/organic-chemistry-webshop-automation" element={<QaCaseStudy projectKey="organic" />} />
      <Route path="projects/quality-operations-monitoring-dashboard" element={<QaCaseStudy projectKey="monitoring" />} />
      <Route path="capabilities" element={<Capabilities />} />
      <Route path="archive/*" element={<ArchiveRedirect />} />
      <Route path="contact" element={<LocalizedContact />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="legal" element={<Legal />} />
    </Route>
    <Route path="/case-study" element={<Navigate to="/de/projects/" replace />} />
    <Route path="/case-study-2" element={<Navigate to="/de/projects/" replace />} />
    <Route path="/case-study2" element={<Navigate to="/de/projects/" replace />} />
    <Route path="*" element={<Navigate to="/de/" replace />} />
  </Routes></>;
}
